module.exports = __webpack_public_path__ + "static/flags/LY-cdcb7054058c4f85cfd79786d9eb80b4.gif";